import { isPlainObject } from '../../../support/helpers';
import { withProperties } from '../../utils';
import { UPDATE_INFO } from '../helpers/actions';

export default function state() {
    const NAME = "info";
    const $state = Object.create(null);

    function Reducer(state = null, action) {
        const payload = isPlainObject(action.payload) ? action.payload : {};

        switch(action.type) {
            case UPDATE_INFO: {
                const { info } = payload;
                return info || null;
            }

            default: return state;
        }
    }

    function updateInfo(info) {
        return (dispatch) => {
            dispatch({ type: UPDATE_INFO, payload: {
                info: info
            } })
        }
    }

    withProperties($state, {
        NAME,
        Reducer,
        actions: withProperties(Object.create(null), { updateInfo }),
    });

    return (state = $state);
}